<app-frequency-selector
  [frequency]="frequency"
  [selectedDays]="selectedDays"
  [isMonthlyDelivery]="isMonthlyDelivery"
  (frequencyChange)="onFrequencyChange($event)"
  (selectedDaysChange)="onSelectedDaysChange($event)"
>
</app-frequency-selector>
